<template>
    <VirtualScroll id="table-component" :items="sortedArticles" :item-height="60">
        <template slot-scope="virtualScroll">
            <table class="table table-striped ">
                <thead>
                    <tr>
                        <th
                            v-for="column in columns"
                            :key="column.key"
                            :class="{ currentSortCriteria: currentSortCriteria.column === column }"
                            :style="column.thStyle"
                            @click="setSorting(column)"
                        >
                            {{ column.label }}
                            <font-awesome-icon
                                v-if="currentSortCriteria.column === column"
                                :icon="currentSortCriteria.faIcon"
                            />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(article, index) in virtualScroll.visibleItems"
                        :key="article.pzn"
                        :class="{ selected: article.selected }"
                    >
                        <td v-for="column in columns" :key="column.key" :class="column.class">
                            <template>
                                <slot
                                    v-if="column.isNumberField"
                                    :name="'numberField'"
                                    :numberObj="{
                                        value: article[column.key],
                                        withoutComma: column.withoutComma
                                    }"
                                >
                                    {{ article[column.key] }}
                                </slot>
                                <slot
                                    v-else
                                    :name="'cell(' + column.key + ')'"
                                    :article="{ ...article, index: index }"
                                >
                                    {{ article[column.key] }}
                                </slot>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </VirtualScroll>
</template>

<script>
import VirtualScroll from "@/views/shared/widgets/VirtualScroll";
export default {
    name: "TableLayout",
    components: { VirtualScroll },
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
        columns: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentSortCriteria: {
                column: null,
                ascending: true,
                faIcon: null
            }
        };
    },
    computed: {
        sortedArticles() {
            const column = this.currentSortCriteria.column;
            const ascending = this.currentSortCriteria.ascending;
            let item = this.tableData;
            if (!column) {
                return item.sort((a, b) => a.ranking - b.ranking);
            }
            if (column.isNumberField) {
                return item.sort(function(a, b) {
                    if (!ascending) {
                        return b[column.key] - a[column.key];
                    }
                    return a[column.key] - b[column.key];
                });
            } else {
                // string sorting
                return item.sort(function(a, b) {
                    if (!ascending) {
                        return ("" + b[column.key]).localeCompare(a[column.key]);
                    }
                    // ("" + val) casts val to a string
                    return ("" + a[column.key]).localeCompare(b[column.key]);
                });
            }
        }
    },
    methods: {
        setSorting(column) {
            // do nothing if column isn't sortable
            if (!column.sortable) {
                // reset Sorting
                this.currentSortCriteria.column = false;
                return;
            }
            // toggle column sort mode only after second click
            // on 3rd click, go back to initial sort
            if (this.currentSortCriteria.column === column) {
                if (!this.currentSortCriteria.ascending) {
                    this.currentSortCriteria.column = false;
                    return;
                } else {
                    this.currentSortCriteria.ascending = false;
                }
            } else {
                this.currentSortCriteria.ascending = true;
            }
            // finally set current column
            this.currentSortCriteria.column = column;
            // aaand the proper font awesome icon
            this.currentSortCriteria.faIcon =
                "sort-" +
                (column.isNumberField ? "numeric" : "alpha") +
                (this.currentSortCriteria.ascending ? "-down" : "-up");
        }
    }
};
</script>

<style lang="scss" scoped>
/** position sticky only works on th, not on thead or even tr **/
.table thead th {
    position: sticky;
    top: -1px;
    background: white;
    border-bottom: 1px solid $gray;
}
thead {
    line-height: 1.2;
}
tr.selected {
    color: rgba(0, 0, 0, 0.42);
}
</style>
